import { render, staticRenderFns } from "./GlobalSidemenu.vue?vue&type=template&id=41cea4d4&"
import script from "./GlobalSidemenu.vue?vue&type=script&lang=js&"
export * from "./GlobalSidemenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports